import React from 'react';

export default function ClockworkCollarSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Leather strap */}
      <rect x="2" y="17" width="36" height="7" rx="1.5" fill="#5D4037" />
      {/* Leather edge highlight */}
      <rect x="2" y="17" width="36" height="1" fill="#8D6E63" opacity="0.7" />
      <rect x="2" y="23" width="36" height="1" fill="#3E2723" opacity="0.8" />
      {/* Stitching */}
      <line x1="4" y1="19" x2="38" y2="19" stroke="#3E2723" strokeWidth="0.4" strokeDasharray="1.5,1.5" />
      <line x1="4" y1="22" x2="38" y2="22" stroke="#3E2723" strokeWidth="0.4" strokeDasharray="1.5,1.5" />
      {/* Buckle on side */}
      <rect x="5" y="18" width="3" height="5" rx="0.5" fill="#8D6E63" stroke="#3E2723" strokeWidth="0.3" />
      {/* Central gear - brass */}
      <circle cx="20" cy="20.5" r="6.5" fill="#B8860B" />
      <circle cx="20" cy="20.5" r="6.5" fill="none" stroke="#5D4037" strokeWidth="0.5" />
      {/* Gear teeth */}
      <rect x="19" y="13" width="2" height="2" fill="#B8860B" />
      <rect x="19" y="26" width="2" height="2" fill="#B8860B" />
      <rect x="13" y="19.5" width="2" height="2" fill="#B8860B" />
      <rect x="25" y="19.5" width="2" height="2" fill="#B8860B" />
      <rect x="15" y="15" width="2" height="2" fill="#B8860B" transform="rotate(45 16 16)" />
      <rect x="23" y="15" width="2" height="2" fill="#B8860B" transform="rotate(45 24 16)" />
      <rect x="15" y="24" width="2" height="2" fill="#B8860B" transform="rotate(45 16 25)" />
      <rect x="23" y="24" width="2" height="2" fill="#B8860B" transform="rotate(45 24 25)" />
      {/* Gear inner ring */}
      <circle cx="20" cy="20.5" r="4" fill="#8B6914" />
      {/* Gear center hole */}
      <circle cx="20" cy="20.5" r="1.5" fill="#3E2723" />
      {/* Brass highlight */}
      <circle cx="18" cy="18.5" r="1.2" fill="#FFD700" opacity="0.5" />
    </svg>
  );
}
